"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCrmConnector = void 0;
var useCrmConnector_1 = require("./useCrmConnector");
Object.defineProperty(exports, "useCrmConnector", { enumerable: true, get: function () { return __importDefault(useCrmConnector_1).default; } });
//# sourceMappingURL=index.js.map